<div class="jh-popup" *ngIf="status && (!IsSessionExpired())">

  <div class="jh-btn-exit">
    <div class="ps-d-button-container">
      <i class="fas fa-times" (click)="close()" onkeypress="close()"></i>
    </div>
  </div>

  <div class="jh-popup-top">
    <div class="jh-popup-header">
      <h2 id="jh-popup-header">Session about to expire</h2>
    </div>
  </div>

  <mat-dialog-content>
    <!-- row -->
    <div class="row">
      <div class="col">
        <p>Due to inactivity your session is about to time out.</p>
        <h1>{{counter}}</h1>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn btn-secondary" (click)="backToMiniPortal()">
      {{exitAppText}}
    </button>
    <button class="btn btn-primary" (click)="keepSessionActive()">
      Continue
    </button>
  </mat-dialog-actions>

</div>


<div class="jh-popup" *ngIf="status && (IsSessionExpired())">

  <div class="jh-popup-top">
    <div class="jh-popup-header">
      <h2 id="jh-popup-header">Session timed out</h2>
    </div>
  </div>

  <mat-dialog-content>
    <div class="row">
      <div class="col">
        <p>Due to inactivity your session has been timed out.</p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button class="btn btn-primary" (click)="backToMiniPortal()">
      {{exitAppText}}
    </button>
  </mat-dialog-actions>

</div>
